import { render, staticRenderFns } from "./AssignmentTravellingSection.vue?vue&type=template&id=7d240d35&scoped=true&"
import script from "./AssignmentTravellingSection.vue?vue&type=script&lang=js&"
export * from "./AssignmentTravellingSection.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentTravellingSection.vue?vue&type=style&index=0&id=7d240d35&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d240d35",
  null
  
)

export default component.exports